import React, { useEffect, useMemo, useState } from "react";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ReactTable from "react-table";
import withFixedColumns from 'react-table-hoc-fixed-columns';
import { getAvailableEvents, getIframes } from "../../../../store/actions/promoterActions";
import moment from "moment";
import NewLoader from "../../../../components/NewLoader/NewLoader";

import "./Iframes.sass";
import ROUTES from "../../../../constants/routes";

export const IframesList = ({
  token,
  getIframes,
  getAvailableEvents,
  loading,
  eventsLoading,
  ...props
}) => {
  const [iframes, setIframes] = useState(null);
  const [events, setEvents] = useState([]);

  const ReactTableFixedColumns = useMemo(() => withFixedColumns(ReactTable), []);

  const getData = async () => {
    const [iframesData, eventsData] = await Promise.all(
      [getIframes(token), getAvailableEvents(token)]
    );

    setIframes(iframesData);
    setEvents(eventsData);
  };

  const goToIframePage = (iframeId) => {
    props.history.push({
      pathname: ROUTES.PROMOTER_IFRAME.replace(":iframeId", iframeId),
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const getStyle = () => ({
    style: {
      minWidth: 'max-content',
    },
  });

  const columns = [
    {
      Header: "Iframe name",
      accessor: "name",
      resizable: false,
      width: 400,
    },
    {
      Header: "Created Date&Time",
      resizable: false,
      width: 220,
      Cell: ({ row: { _original: { createdAtUtc } } }) => {
        
        return <>{moment(createdAtUtc).format("DD MMMM YYYY HH:mm")}</>
      },
    },
    {
      Header: "Active events",
      resizable: false,
      getProps: getStyle,
      Cell: ({ row: { _original: { eventIds, returnEventsToSell } } }) => {
        if (returnEventsToSell) {
          return <>All available events</>
        };

        if (eventIds.length === 0 || events.length === 0) {
          return <>No active events</>
        };

        return eventIds.map((eventId) => {
          const event = events.find(currEvent => currEvent.id === eventId);

          return (
            <div key={eventId} className="iframes-list__event-item">
              {event.name}
              <span>{moment(event.startDate).format("DD.MM.YYYY hh:mm")}</span>
            </div>
          );
        })
      },
    },
  ];

  if ((loading || eventsLoading) && !iframes) {
    return <NewLoader />
  }

  return (
    <section
      className={`
        promoter__iframes
        iframes-list
        ${iframes && iframes.length === 0 ? 'iframes-list--jc-center' : ''}
        membership-managment
      `}
    >
      {iframes && iframes.length !== 0 && (
        <ReactTableFixedColumns
          data={iframes}
          columns={columns}
          showPagination={false}
          minRows={0}
          sortable={false}
          defaultPageSize={999999}
          getTrProps={(state, rowInfo) => ({
            onClick: () => {
              goToIframePage(rowInfo.original.id);
            },
            style: {
              alignItems: "stretch",
            },
          })}
        />
      )}

      {iframes && iframes.length === 0 && (
        <div className="iframes-list__empty-state">
          <img src="/images/img-empty-events.svg" alt="Empty events" />
          <p>Please press the 'Add iFrames' button to create your first iFrame</p>
        </div>
      )}

      <div className="iframes-list__actions">
        <button
          type="button"
          className="btn-primary"
          onClick={() => goToIframePage('new')}
        >
          Add iframe
        </button>
      </div>
    </section>
  )
}

const mapStateToProps = ({ auth, promoter }) => ({
  auth,
  token: auth.user.token,
  loading: promoter.loading,
  eventsLoading: promoter.eventsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getIframes: (token) => dispatch(getIframes(token)),
  getAvailableEvents: (token) => dispatch(getAvailableEvents(token)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(IframesList)
);
